import { endPoint } from './base.config';

export const transaction = {
  get: endPoint + 'v2/transactions/',
  fetchById: endPoint + 'v2/transactions/:id',
  add: endPoint + 'transactions',
  delete: endPoint + 'transactions/:id',
  getYears: endPoint + 'transactions/getYears',
  getStatistic: endPoint + 'transactions/getStatistic',
  getByMonth: endPoint + 'transactions/month',
  updateMissing: endPoint + 'transactions/missing',
  import: endPoint + 'transactions/import',
  importer: endPoint + 'v2/transactions/import-file-upload',
  readFileUpload: endPoint + 'v2/transactions/read-file-upload',
  importDataUpload: endPoint + 'v2/transactions/import-data-upload',
  updateStatus: endPoint + 'transactions/status',
  fetchAll: endPoint + 'transactions/fetchAll?',
  updateMissingByVoucher: endPoint + 'transactions/updateMissingByVoucher',
  updateMissingByAddVoucher: endPoint + 'transactions/updateMissingByAddVoucher',
  getMissingSummary: `${endPoint}transactions/getMissingSummary`,
  getSuggestTransaction: `${endPoint}transactions/getSuggestTransaction`,
  addList: endPoint + 'transactions/addList',
  autoUpdateTransaction: endPoint + 'transactions/autoUpdateTransaction',
  autoUpdateTransactionByAiLocal: endPoint + 'transactions/autoUpdateTransactionByAiLocal',
  getHistory: endPoint + 'transactions/get-history',
  downloadFilePdfPrivateLost: endPoint + 'transactions/export-pdf-private-lost',
};

export const bankTransactionV2 = {
  bulkUpdate: endPoint + 'v2/transactions/bulk-update',
  matchInvoiceTransaction: endPoint + 'v2/transactions/:id/invoice-matching',
  getFikenVoucherPaymentToSync: endPoint + 'v2/bank-transaction-vouchers/:companyId/fiken-payment-to-sync',
};
